import { useState,useEffect } from "react";

//import IconButton from "components/elements/IconButton";
import MonthInput from "components/elements/MonthInput";
//import Select from "components/elements/Select";
import dataProvider from "core/DataProvider";
import toast from "react-hot-toast";
import Exporter from "components/elements/BillinMonthlyExporter";

const getDefaultPeriodFrom = () => {
   const today = new Date();
    const year = today.getMonth() >= 4 ? today.getFullYear() : today.getFullYear() - 1;
    return `${year}-04`;
};

const getDefaultPeriodTo = () => {
    let dt = new Date();
    dt.setMonth(dt.getMonth() - 1);
    const parts = dt.toISOString().split("T")[0].split("-");
    return `${parts[0]}-${parts[1]}`;
};

const customDateFormat = (date) => {
    if (typeof date === "string") {
        try {
            date = new Date(date);
        } catch {
            return date;
        }
    }
    try {
        return new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "short",
        }).format(date);
    } catch {
        return date;
    }
};
function getMonthsBetween(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const months = [];

    if (start > end) return [];

    const current = new Date(start);

    while (current <= end) {
        const month = current.toLocaleString('en-US', { month: 'short' }); // 'Apr'
        const year = current.getFullYear().toString().slice(-2); // 2024 to 24
        months.push(`${month}-${year}`);
        current.setMonth(current.getMonth() + 1);
    }

    return months;
}
const parseMonthsString = (str) => {
    if (!str) return [];

    // Remove the outer braces
    const raw = str.replace(/^{{|}}$/g, "");
    const entries = raw.split("},{");

    return entries.map(entry => {
        const obj = {};
        entry.split(",").forEach(pair => {
            const [key, value] = pair.split(":");

            // If the value contains more colons (like in ISO date), join them back
            if (value && value.trim() !== '') {
                const cleanedKey = key.trim();
                if (value.includes("T")) {
                    const remaining = pair.split(":").slice(1).join(":").trim();
                    obj[cleanedKey] = remaining;
                } else {
                    obj[cleanedKey] = value.trim();
                }
            }

        });
        return obj;
    });
};
const BillingMonthReportRequest = (props) => {
    const [loading, setLoading] = useState(false);
    const [formVisible, setFormVisible] = useState(true);
    const [billingMonthFrom, setBillingMonthFrom] = useState(getDefaultPeriodFrom());
    const [billingMonthTo, setBillingMonthTo] = useState(getDefaultPeriodTo());
    const [reportType, setReportType] = useState('csv');
    //   const [reportData, setReportData] = useState([]);
    const [reportData_filter, setreportData_filter] = useState([]);

    //   const [ReportTypeCall, setReportTypeCall] = useState([]);
    const months = getMonthsBetween(billingMonthFrom, billingMonthTo);
    //console.log('selected months', months);
    const months_spots = months.map(label => `Spots-${label}`);
    const months_bill = months.map(label => `Bill-${label}`);
    const exportHeaders = [
        { label: "Group Name", key: "GroupName" },
        { label: "FY", key: "DataFy" },
        { label: "Group Spots", key: "GroupSpot" },
        ...months_spots.map(month => ({ label: month, key: month })),
        { label: "Total Spots", key: "total_spots" },
        ...months_bill.map(month => ({ label: month, key: month })),
        { label: "Total Bill Amount", key: "total_bill" },
    ];
    const handleReportTypeChange = async (selectedOption,billingMonthFrom,billingMonthTo) => {
      //  console.log('typ',selectedOption);
        setReportType(selectedOption);

       // if (!selectedOption) return;
setBillingMonthFrom(billingMonthFrom);
setBillingMonthTo(billingMonthTo);
        try {

            const data = await dataProvider.network.get(
                `billing/group-monthwise-report/${billingMonthFrom}/${billingMonthTo}`
            );
            if (!data || data.length === 0) {
              //  toast("No data found for the selected filters.");
               // setreportData_filter([]); // Optional: reset previous data
               setLoading(false);
                return;
            }
            const reportData_filter_data = (data, months) => {
    return data.flatMap(group => {
        const monthsData = parseMonthsString(group.Months); // array of { BillingMonth, TotalSpots, TotalAmount }

        let total_spots = 0, total_bill = 0, extractedValuesMap = {};
        const baseRow = {
            GroupName: group.GroupName,
            GroupSpot: group.GroupSpot,
            DataFy: group.FinancialYear
        };

        months.forEach(item => {
            const item_date = new Date('01-' + item);
            const compare_month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(item_date);
            const compare_year = item_date.getFullYear().toString().slice(-2);
            const compare_str = `${compare_month}-${compare_year}`;
            const compare_str_s = `Spots-${compare_str}`;
            const compare_str_b = `Bill-${compare_str}`;

            const matches = (monthsData || []).filter(md => {
                const date = new Date(md.BillingMonth);
                if (isNaN(date)) return false;

                const month = new Intl.DateTimeFormat("en-US", { month: "short" }).format(date);
                const year = date.getFullYear().toString().slice(-2);
                return `${month}-${year}` === compare_str;
            });

            if (!extractedValuesMap[compare_str]) {
                extractedValuesMap[compare_str] = matches.map(m => ({
                    TotalSpots: parseInt(m.TotalSpots, 10),
                    TotalAmount: parseFloat(m.TotalAmount)
                }));
            }

            const primaryMatch = matches[0];

            baseRow[compare_str_s] = primaryMatch ? parseInt(primaryMatch.TotalSpots, 10) : 0;
            baseRow[compare_str_b] = primaryMatch ? parseFloat(primaryMatch.TotalAmount) : 0;

            total_spots += primaryMatch ? parseInt(primaryMatch.TotalSpots, 10) : 0;
            total_bill += primaryMatch ? parseFloat(primaryMatch.TotalAmount) : 0;
        });

        baseRow.total_spots = total_spots;
        baseRow.total_bill = total_bill;

        // Start with the base row
        const resultRows = [baseRow];

        // Now create duplicates if there are additional matches per month
        let duplicateCount = 1;
        for (const monthKey in extractedValuesMap) {
            const monthValues = extractedValuesMap[monthKey];

            if (monthValues.length > 1) {
                for (let i = 1; i < monthValues.length; i++) {
                    const dupRow = {
                        GroupName: group.GroupName + ` (dup-${duplicateCount})`,
                        GroupSpot: group.GroupSpot,
                        DataFy: group.FinancialYear,
                        total_spots: monthValues[i].TotalSpots,
                        total_bill: monthValues[i].TotalAmount
                    };
                    dupRow[`Spots-${monthKey}`] = monthValues[i].TotalSpots;
                    dupRow[`Bill-${monthKey}`] = monthValues[i].TotalAmount;
                    resultRows.push(dupRow);
                    duplicateCount++;
                }
            }
        }

        return resultRows;
    });
};


            const filteredData = reportData_filter_data(data, months); // ✅ make sure `months` is defined before this line
            //  console.log('selected final data', filteredData);
            setreportData_filter(filteredData);
            //   console.log('filtered data', filteredData);
            //setFormVisible(true);
        } catch (error) {
            console.error("API error:", error);
            toast.error("Failed to generate reports");
            if (error?.response?.data?.error) {
                toast.error(error.response.data.error);
            }
        } finally {
            setLoading(false);
        }

    };
 useEffect(() => {
    handleReportTypeChange(reportType,billingMonthFrom,billingMonthTo);

 }, []);
    //const handleCancel = () => {
      //  setFormVisible(true);

   // };
    return (
        <div className="billing-request">
            <div className="flex right flex-v-center" style={{ justifyContent: "flex-end" }}>


            </div>

            {
                formVisible && (
                    <div className="box mtop">
                        <div className="flex flex-v-center pad-lr">
                            <h3></h3>
                            <div className="flex flex-full" style={{ justifyContent: "flex-end" }}>
                                <div className="el" style={{ minWidth: "200px" }}>
                                    <MonthInput
                                        value={billingMonthFrom}
                                        onChange={(value) => {
                                            setBillingMonthFrom(value);
                                            handleReportTypeChange(reportType,value,billingMonthTo);
                                        }}
                                        placeholder="Month From"
                                        customFormat={customDateFormat}
                                    />
                                </div>
                                <div className="el" style={{ minWidth: "200px" }}>
                                    <MonthInput
                                        value={billingMonthTo}
                                        onChange={(value) => {
                                            setBillingMonthTo(value);
                                            handleReportTypeChange(reportType,billingMonthFrom,value);
                                        }}
                                        placeholder="Month To"
                                        customFormat={customDateFormat}
                                    />
                                </div>

                                <Exporter
                                    format={reportType}
                                    data={reportData_filter}
                                    headers={exportHeaders}
                                    filename={`billing_report_${billingMonthFrom}_${billingMonthTo}.${reportType}`}
                                // you can pass if your Exporter needs a file id for PDF downloads
                                // pass if needed for PDF download links

                                />
                            </div>
                        </div>
                    </div>
                )
            }
        </div >
    );
};

export default BillingMonthReportRequest;
